import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BarChart = () => {
  const data = {
    labels: ["₹0–2.5L", "₹2.5L–5L", "₹5L–10L", "₹10L–15L", "₹15L+"],
    datasets: [
      {
        label: "Number of Employees",
        data: [220, 340, 460, 130, 70], // sample data
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;
          if (!chartArea) return null;
          const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
          gradient.addColorStop(0, "#7b2ff7"); // bottom - deep purple
          gradient.addColorStop(0.5, "#9f5cff"); // middle - bright violet
          gradient.addColorStop(1, "#d17fff"); // top - light lavender
          return gradient;
        },
        borderRadius: 6,
        barThickness: 60,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: false,
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#ccc",
          font: { size: 14 },
        },
        // grid: {
        //   color: "rgba(255,255,255,0.1)",
        // },
      },
      y: {
        ticks: {
          color: "#ccc",
          font: { size: 14 },
          stepSize: 100,
        },
        grid: {
          color: "rgba(255,255,255,0.1)",
        },
        title: {
          display: true,
          text: "Number of Employees",
          color: "#ccc",
          font: { size: 16 },
        },
      },
    },
  };

  return (
    <div
      // style={{
      //   background: "linear-gradient(180deg, #0b0b0b, #1a1a1a)",
      //   padding: "20px",
      //   borderRadius: "16px",
      // }}
    >
      <Bar data={data} options={options} />
    </div>
  );
};

export default BarChart;
